import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import MarcasCarousel from './MarcasCarousel';
import './Nosotros.css';

const Nosotros = () => {
  const backgroundImageUrl = `${process.env.PUBLIC_URL || ''}/images/NOSOTROS_fondo.svg`;
  const backgroundStyle = {
    backgroundImage: `url("${backgroundImageUrl}")`,
  };

  return (
    <div className="nosotros-page">
      <div className="nosotros-background" style={backgroundStyle}></div>
      <Header />
      <div className="page-content">
        <div className="nosotros-header">
          <h1>¿QUIÉNES SOMOS?</h1>
          <h2 className="nosotros-subtitle">Soluciones Eléctricas y Electromecánicas</h2>
        </div>

        <div className="nosotros-intro">
          <p>
            <strong>Solectric</strong> es una empresa líder en soluciones eléctricas y electromecánicas, especializada en la comercialización de productos eléctricos de <strong>alta tecnología</strong> y en el desarrollo de <strong>ingeniería de valor</strong> aplicada a proyectos de <strong>infraestructura crítica</strong>, <strong>eficiencia energética</strong> y <strong>energías renovables</strong>. Contamos con un equipo técnico con más de <strong>20 años de experiencia</strong>, enfocado en brindar soluciones <strong>confiables, eficientes y sostenibles</strong>, alineadas a las necesidades reales de cada proyecto.
          </p>
          <p>
            Como parte de nuestro plan estratégico de crecimiento y en respuesta a la evolución del mercado energético, en julio de 2022 se constituye <strong>Solectric S.A.</strong>, consolidándonos como distribuidores autorizados de <strong>Siemens</strong> para soluciones de <strong>baja y media tensión</strong>, así como promotores de sistemas de <strong>control industrial</strong>, <strong>automatización de procesos</strong> y soluciones para la <strong>transición energética</strong>.
          </p>
        </div>

        <div className="nosotros-services">
          <p className="nosotros-section-title">
            ENFOQUE Y ESPECIALIZACIÓN
          </p>
          <p>
            <strong>Solectric S.A.</strong> está enfocada en atender las necesidades electromecánicas de proyectos de <strong>agua, energía, infraestructura y energías renovables</strong> en Panamá, integrando soluciones que contribuyen a la <strong>descarbonización</strong>, <strong>eficiencia energética</strong> y uso responsable de los recursos. Ofrecemos soluciones integrales que combinan <strong>ingeniería especializada</strong>, tecnología de primer nivel y acompañamiento técnico desde la etapa de <strong>diseño hasta la implementación</strong>, garantizando <strong>confiabilidad operativa</strong>, <strong>sostenibilidad</strong> y alto desempeño.
          </p>
        </div>

        <div className="nosotros-differentiator">
          <p className="nosotros-section-title">
            DIFERENCIADOR TÉCNICO
          </p>
          <p>
            <strong>Solectric</strong> es uno de los pocos distribuidores de material eléctrico en Panamá que cuenta con un <strong>departamento técnico especializado</strong>, capaz de evaluar y validar <strong>planos eléctricos</strong>, desarrollar <strong>presupuestos eléctricos</strong> con <strong>ingeniería de valor</strong> y proponer soluciones optimizadas con enfoque en <strong>eficiencia energética</strong>, <strong>sostenibilidad</strong> y <strong>cumplimiento normativo</strong>.
          </p>
        </div>

        <div className="nosotros-alliances">
          <p className="nosotros-section-title">
            ALIANZAS TECNOLÓGICAS
          </p>
          <p className="nosotros-alliances-intro">
            Trabajamos de la mano con <strong>socios tecnológicos líderes</strong> a nivel global, lo que nos permite ofrecer soluciones <strong>robustas, certificadas</strong> y alineadas con los más altos estándares de <strong>eficiencia</strong>, <strong>sostenibilidad</strong> y <strong>continuidad operativa</strong>:
          </p>
          <div className="nosotros-alliances-carousel">
            <MarcasCarousel />
          </div>
        </div>

        <div className="nosotros-boxes">
          <div className="nosotros-cuadro">
            <h3 className="nosotros-cuadro-title">Nuestra misión</h3>
            <p className="nosotros-cuadro-text">
              Ser la <strong>mejor solución tecnológica, electromecánica y sostenible</strong> para nuestros clientes, ofreciendo <strong>ingeniería de valor</strong>, <strong>tecnologías de clase mundial</strong> y <strong>soporte técnico especializado</strong>, contribuyendo activamente a la <strong>transición energética</strong>, la <strong>eficiencia operativa</strong> y el <strong>desarrollo sostenible</strong> del país.
            </p>
          </div>
          <div className="nosotros-cuadro">
            <h3 className="nosotros-cuadro-title">Nuestra visión</h3>
            <p className="nosotros-cuadro-text">
              Ser la empresa de <strong>referencia</strong> en soluciones eléctricas y electromecánicas en <strong>Panamá y la región</strong>, reconocida por nuestra alianza con socios como <strong>Siemens</strong>, nuestra <strong>capacidad técnica</strong> y nuestro compromiso con la <strong>transición energética</strong>, la <strong>eficiencia</strong> y la <strong>sostenibilidad</strong>.
            </p>
          </div>
          <div className="nosotros-cuadro">
            <h3 className="nosotros-cuadro-title">Valores y filosofía</h3>
            <p className="nosotros-cuadro-text">
              La filosofía de Solectric se basa en la <strong>excelencia técnica</strong>, la <strong>integridad</strong> y la <strong>ingeniería de valor</strong>, con compromiso en <strong>eficiencia energética</strong>, <strong>sostenibilidad</strong> y <strong>cumplimiento normativo</strong>, trabajando con <strong>transparencia</strong> e <strong>innovación</strong> en cada proyecto y cliente.
            </p>
          </div>
        </div>

        <div className="nosotros-cta">
          <Link to="/proyectos" className="historia-button">
            Explorar Proyectos
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Nosotros;

